console.clear();

var d3 = {
  ...require("d3-axis/dist/d3-axis.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-selection/dist/d3-selection.min"),
  ...require("d3-geo/dist/d3-geo.min"),
  ...require("d3-array/dist/d3-array.min"),
  ...require("d3-scale-chromatic/dist/d3-scale-chromatic.min")
};

var textures = require("./lib/textures");

var displayAttributes = [{"mode": "binary",
                          "world_map": "abortion_law"}];

var topojson = require("topojson-client/dist/topojson-client.min");
var geoData = require("./data/countries_abortion.json");

var box = require("./data/boundingbox.json");

var { COLORS, classify, makeTranslate, formatStyle, wrapText } = require("./lib/helpers");
var { isMobile } = require("./lib/breakpoints");


module.exports = function(config) {

  // Clear existing graphic (for redraw)
  var containerElement = d3.select(config.container);
  containerElement.html("");

  var attributes = displayAttributes.filter(x => x.mode == "binary")[0];

  var colorScale = d3.scaleOrdinal()
    .domain(Object.keys(CATEGORIES).sort())
    .range([
      "#db4325",
      "#eea551",
      "#e7e2bd",
      "#5cc3af",
      "#0a6265",
      "#0a6265",
      "#ddd"
    ]);

  var maxTooltipWidth = 275;
  var tooltip = containerElement.append("div")
    .attr("class", "tooltip")
    .style("display", "none");


  function renderLegend(){
    //Render the legend
    var legend = containerElement
      .append("ul")
      .attr("class", "key")
      .selectAll("g")
      .data(colorScale.domain().slice(0,5)) //don't include US category
      .enter()
        .append("li")
        .attr("class", (d, i) => `key-item key-${i} ${classify(d)}`);

    legend.append("b")
      .style("background-color", d => colorScale(d));

    legend.append("label").text(d => CATEGORIES[d]);
  }

  function renderMap(){
    var countriesData = topojson.feature(geoData,geoData.objects["countries_abortion"]);

    //join data from table
    for(var row of config.data){
      var table_id = row["npr_name"];
      //get feature
      var i = countriesData.features.findIndex(c=>c.properties["npr_name"] == table_id);
      if(i != -1) countriesData.features[i].table_props = row
    }

    // Setup //
     var margins = {
      top: 5,
      right: 5,
      bottom: 0,
      left: 5
    };

    // Calculate actual chart dimensions
    var chartWidth = config.width - margins.left - margins.right;
    var chartHeight = chartWidth*.55; //global map aspect ratio
    // var chartHeight = isMobile.matches ? chartWidth : chartWidth*2/3;

    // map setup //
    var equalEarth = d3.geoEqualEarth()
      .rotate([-15, 0])
      .fitSize([chartWidth,chartHeight],box);

    var path = d3.geoPath().projection(equalEarth);

    //create svg for map
    var mapWrapper = containerElement
        .append("div")
        .attr("class", "map-wrapper");

    var mapElement = mapWrapper
      .append("svg")
      .attr("width", chartWidth + margins.left + margins.right)
      .attr("height", chartHeight + margins.top + margins.bottom)
      .append("g")
      .attr("transform", `translate(${margins.left},${margins.top})`);

    //add countries
    var countries = mapElement.selectAll(".country")
      .data(countriesData.features)
      .enter()
      .append("path")
        .attr("class", "country")
        .attr("geoid", d=>`c${d.properties["npr_name"]}`)
        .attr("d", path)
        .attr("stroke", d=> "#fff")
        .attr("fill", d=> d.table_props ? colorScale(d.table_props[attributes["world_map"]]) : "#ddd");

    //add special pattern fill for United States
    const texture = textures
      .lines()
      .thicker()
      .stroke("#db4325");

    mapElement.call(texture);

    countries.filter(c => c.properties.npr_name == "United States")
                .clone(true)
                .attr("fill", texture.url())
                .style("pointer-events", "none");


    //add highlighting
    countries.on("mouseover", function(d){
        if(isMobile.matches) return;
        var el = d3.select(this);
        var geoid = el.attr("geoid");
        var targets = d3.selectAll(`[geoid='${geoid}']`);
        targets.classed("highlight", function(d) {
          if (d.table_props) {
            return true;
          }
        });
        targets.raise();
        addTooltip(d);
      }).on("mousemove", function(){
          if(isMobile.matches) return;
          moveTooltip(d3.mouse(containerElement.node()));
      })
      .on("mouseout", function(){
        if(isMobile.matches) return;
        var el = d3.select(this);
        var geoid = el.attr("geoid");
        var targets = d3.selectAll(`[geoid='${geoid}']`);
        targets.classed("highlight", false);
        //remove tooltip
        tooltip.style("display", "none");
      })
  }

  function addTooltip(d){
    tooltip.style("display", "block");
    tooltip.html("");

    var content = tooltip.append("div").attr("class", "content");

    if(d.table_props){

      //check for abortion and unintended pregnancy data, add table
      var abortionRate = d.table_props["abortion_estimate"] ? `<span class='val'>${d.table_props["abortion_estimate"]}</span> per 1,000 women of reproductive age<span class="footnote">â¡</span> annually` : "NA";
      var unintendedPregnancyRate = d.table_props["unintended_pregnancy_estimate"] ? `<span class='val'>${d.table_props["unintended_pregnancy_estimate"]}</span> per 1,000 women of reproductive age<span class="footnote">â¡</span> annually` : "NA";

      var innerContent = `<h4>${d.table_props["npr_name"]}</h4>
                          <table>
                            <tbody>
                              <tr>
                                <td>Legal status of abortion:</td>
                                <td>${CATEGORIES[d.table_props["abortion_law"]]}</td>
                              </tr>
                              <tr>
                                <td>Abortions:<br>(estimate)<span class="footnote">â </span></td>
                                <td>${abortionRate}</td>
                              </tr>
                              <tr>
                                <td>Unintended pregnancies:<br>(estimate)<span class="footnote">â </span></td>
                                <td>${unintendedPregnancyRate}</td>
                              </tr>
                            </tbody>
                          </table>`;

      content.html(innerContent);

    } else {
      content.append("h4").text(d.properties["npr_name"]);
      content.append("p").text("No data");
    }
  }

  function moveTooltip(mousePosition){
    var top = mousePosition[1]+10;
    var left = mousePosition[0]+10;

    //get bounding box of container
    var bbox = containerElement.node().getBoundingClientRect();

    var tooFarRight = (left + maxTooltipWidth) > bbox.width;
    //if the right side is too far right, shift tooltip left
    if(tooFarRight){
      var right = bbox.width - mousePosition[0]+10;
      tooltip.style("left", "auto");
      tooltip.style("right", right+"px")

    } else {
      tooltip.style("right", "auto");
      tooltip.style("left", left+"px")
    }

    tooltip.style("top", top+"px");
  }

  renderLegend();
  renderMap();
};
